module.exports = {
  docsMap: {
    "University Acceptance Letter": "University Acceptance Letter",
    "Student registration contract": "Student registration contract",
    "Payslip month 1": "1st month payslip",
    "Payslip month 2": "2nd month payslip",
    "Payslip month 3": "3rd month payslip",
    "Payslip Month 1": "1st month payslip",
    "Payslip Month 2": "2nd month payslip",
    "Payslip Month 3": "3rd month payslip",
    "Social Security Contribution Report": "Deduction certificate",
    "Employment contract": "Employment contract",
    "Annual payment certificate": "Annual payment certificate",
    "Deduction certificate": "Deduction certificate",
    "Working life certificate": "Working life certificate",
    "Last annual Tax Report (Model 100)": "Last annual Tax Report (Model 100)",
    "Last Fractionated Tax Report (Model 130)":
      "Last Fractionated Tax Report (Model 130)",
    "Last quarterly VAT tax (Form 303)": "Last quarterly VAT tax (Form 303)",
    "Comprehensive certificate of benefits":
      "Comprehensive certificate of benefits",
    "Last revalorization letter": "Last revalorization letter",
    "Last year's Corporate Tax Return": "Last year's Corporate Tax Return",
    "Last year's Corporate balance sheet":
      "Last year's Corporate balance sheet",
  },
  forensic_docs_map: {
    student: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          "University Acceptance Letter",
          "Student registration contract",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [],
        additional: ["Payslip"],
      },
    },
    employed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Employment contract", "Working life certificate"],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          // "Payslip",
          "Payslip month 1",
          "Payslip month 2",
          "Payslip month 3",
          "Deduction certificate",
          "Last annual Tax Report (Model 100)",
        ],
        additional: [],
      },
    },
    domestic_worker: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Employment contract", "Working life certificate"],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Annual payment certificate",
          "Deduction certificate",
          "Last annual Tax Report (Model 100)",
        ],
        additional: ["Payslip"],
      },
    },
    freelancer: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          // "Employment contract",
          "Working life certificate",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Last annual Tax Report (Model 100)",
          "Last Fractionated Tax Report (Model 130)",
          "Deduction certificate",
          "Last quarterly VAT tax (Form 303)",
        ],
        additional: ["Payslip"],
      },
    },
    retired: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Comprehensive certificate of benefits",
          "Last revalorization letter",
          "Last annual Tax Report (Model 100)",
        ],
        additional: [],
      },
    },
    unemployed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Working life certificate"],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Comprehensive certificate of benefits",
          "Last annual Tax Report (Model 100)",
        ],
        additional: [],
      },
    },
    ownACompany: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          "Working life certificate",
          "Company Incorporation Documents",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Last annual Tax Report (Model 100)",
          "Last Fractionated Tax Report (Model 130)",
          "Deduction certificate",
          "Last year's Corporate Tax Return",
          "Last year's Corporate balance sheet",
          "Last year's Corporate P&L",
        ],
        additional: ["Payslip"],
      },
    },
    public_servant: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          "Working life certificate",
          "Official Appointment Notice (Official Gazette)",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Last annual Tax Report (Model 100)",
          // "Payslip",
          "Payslip month 1",
          "Payslip month 2",
          "Payslip month 3",
          "Deduction certificate",
        ],
        additional: [],
      },
    },
    company: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Company Incorporation Documents"],
      income_taxes: [
        "Last year's Corporate Tax Return",
        "Last quarterly VAT tax (Form 303) Q1",
        "Last quarterly VAT tax (Form 303) Q2",
        "Last quarterly VAT tax (Form 303) Q3",
        "Last quarterly VAT tax (Form 303) Q4",
      ],
    },
  },
  dea_missing_docs: {
    student: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [],
        additional: [],
      },
      income_taxes: {
        compulsory: [],
        additional: [],
      },
    },
    employed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Employment contract", "Working life certificate"],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          // "Payslip",
          "Payslip month 1",
          "Payslip month 2",
          "Payslip month 3",
        ],
        additional: [
          "Deduction certificate",
          "Last annual Tax Report (Model 100)",
        ],
      },
    },
    // domestic_worker: {
    //   identification: [
    //     "passport",
    //     "national_identity_card_front",
    //     "national_identity_card_back",
    //     "residence_permit_front",
    //     "residence_permit_back",
    //   ],
    //   employment_status: { compulsory: ["Employment contract", "Working life certificate"], additional: [] },
    //   income_taxes: { compulsory: ["Annual payment certificate"], additional: [] },
    // },
    freelancer: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Working life certificate"],
        additional: ["Employment contract"],
      },
      income_taxes: {
        compulsory: [
          "Last annual Tax Report (Model 100)",
          "Last quarterly VAT tax (Form 303)",
        ],
        additional: [
          "Deduction certificate",
          "Last Fractionated Tax Report (Model 130)",
        ],
      },
    },
    retired: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Comprehensive certificate of benefits",
          "Last revalorization letter",
        ],
        additional: [""],
      },
    },
    unemployed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [],
        additional: ["Working life certificate"],
      },
      income_taxes: {
        compulsory: [],
        additional: [
          "Last annual Tax Report (Model 100)",
          "Comprehensive certificate of benefits",
        ],
      },
    },
    ownACompany: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          "Working life certificate",
          "Company Incorporation Documents",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Last annual Tax Report (Model 100)",
          "Last year's Corporate Tax Return",
        ],
        additional: [
          "Last Fractionated Tax Report (Model 130)",
          "Deduction certificate",
          "Last year's Corporate balance sheet",
          "Last year's Corporate P&L",
          "Payslip",
        ],
      },
    },
    public_servant: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: [
          "Working life certificate",
          "Official Appointment Notice (Official Gazette)",
        ],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          // "Payslip",
          "Payslip month 1",
          "Payslip month 2",
          "Payslip month 3",
        ],
        additional: [
          "Deduction certificate",
          "Last annual Tax Report (Model 100)",
        ],
      },
    },
    company: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: {
        compulsory: ["Company Incorporation Documents"],
        additional: [],
      },
      income_taxes: {
        compulsory: [
          "Last year's Corporate Tax Return",
          "Last quarterly VAT tax (Form 303) Q1",
          "Last quarterly VAT tax (Form 303) Q2",
          "Last quarterly VAT tax (Form 303) Q3",
          "Last quarterly VAT tax (Form 303) Q4",
        ],
        additional: [],
      },
    },
  },
};
